import { useState } from "react";
import { useDispatch, useSelector } from "react-redux"

import { resetModalCard } from '../../redux/slices/modalCard.js'
import DivTrailer from "../DivTrailer/DivTrailer.js";

const ModalCard = () => {

    const dispatch = useDispatch();
    const data = useSelector(state => state.modalCard.data)
    const [trailer, setTrailer] = useState(false)

    const handleClick = () => {
        dispatch(resetModalCard());
    }


    return data !== null
        ? (
            <div className="fl-cl modalCard__container">
                {
                    trailer
                        ? <button className="modalCard__button__izq" onClick={() => setTrailer(false)}>←</button>
                        : undefined
                }
                <button className="modalCard__button__x" onClick={handleClick}>x</button>
                <div className="modalCard__container__divImg">
                    <img className="modalCard__divImg" src={data.img} alt={data.title} />
                </div>
                <div className="modalCard__container__details">
                    <div className="modalCard__minDiv">
                        <h2>{data.title}</h2>
                        <p>{data.description}</p>
                    </div>
                    <div className="modalCard__minDiv">
                        <h3>Genero: </h3>
                        {
                            data.category && data.category.map((c, i) => i === data.category.length - 1
                                ? (<span key={data.title + c}>{c}.</span>)
                                : (<span key={data.title + c}>{c}, </span>))
                        }
                    </div>
                    {
                        !!data.season
                            ? (
                                <div className="modalCard__minDiv">
                                    <h3>Temporada: </h3><span>{data.season}</span>
                                </div>
                            )
                            : undefined
                    }
                    <div className="modalCard__minDiv">
                        <h3>Director: </h3>
                        <span>{data.director}</span>
                    </div>
                    <div className="modalCard__minDiv">
                        <h3>Actores: </h3>
                        {
                            data.actors && data.actors.map((a, i) => i === data.actors.length - 1
                                ? (<span key={data.title + a}>{a}.</span>)
                                : (<span key={data.title + a}>{a}, </span>))
                        }
                    </div>
                    <div className="modalCard__minDiv">
                        <button onClick={() => setTrailer(!trailer)}>Trailer</button>
                    </div>
                    {
                        trailer
                            ? <DivTrailer title={data.title} trailer={data.trailer} />
                            : undefined
                    }
                </div>
            </div>
        )
        : undefined
}

export default ModalCard